import { canManageUpgradesPosts } from '@/general/src/auth/can.js'
import { zUpdateUpgradePostForAdminEndpointInput } from '@/general/src/upgradePost/routes/updateUpgradePostForAdmin/input.js'
import { GeneralLayout } from '@/webapp/src/components/layout/GeneralLayout/index.js'
import { Textary, Textfieldy, useFormy } from '@/webapp/src/lib/formy.js'
import { withPageWrapper } from '@/webapp/src/lib/pageWrapper.js'
import { adminUpgradePostEditRoute } from '@/webapp/src/lib/routes.js'
import { trpc } from '@/webapp/src/lib/trpc.js'
import { Block, Button, Buttons, FormItems, Segment } from '@/webapp/src/lib/uninty.components.js'
import { useRouteParams } from '@/webapp/src/lib/useRoute.js'

export const AdminUpgradePostEditPage = withPageWrapper({
  title: 'Редактирование новости обновления',
  Layout: GeneralLayout,
  authorizedAdminsOnly: true,
  useQuery: () => {
    const { routeParams } = useRouteParams(adminUpgradePostEditRoute)
    return trpc.getUpgradePostForAdmin.useQuery({
      upgradePostSn: +routeParams.upgradePostSn,
    })
  },
  checkAccess: ({ ctx }) => canManageUpgradesPosts(ctx.me.admin),
  setProps: ({ queryResult }) => ({
    upgradePost: queryResult.data.upgradePost,
  }),
})(({ upgradePost }) => {
  const updateUpgradePostForAdmin = trpc.updateUpgradePostForAdmin.useMutation()
  const trpcUtils = trpc.useUtils()
  const formy = useFormy({
    initialValues: {
      upgradePostId: upgradePost.id,
      title: upgradePost.title || '',
      desktopappVersion: upgradePost.desktopappVersion || '',
      publishedAt: upgradePost.publishedAt.toISOString() as never,
      contentMd: upgradePost.contentMd || '',
    },
    validationSchema: zUpdateUpgradePostForAdminEndpointInput,
    onSubmit: async ({ valuesInput }) => {
      const res = await updateUpgradePostForAdmin.mutateAsync({
        ...valuesInput,
      })
      trpcUtils.getUpgradePostForAdmin.setData({ upgradePostSn: res.upgradePost.sn }, res)
    },
    successMessage: 'Новость обновления обновлена',
  })
  return (
    <Block fcnw>
      <Segment title={`Новость обновления #${upgradePost.sn}`} size="m">
        <FormItems as="form" {...formy.formProps}>
          <Textfieldy label="Название новости" {...formy.getFieldProps('title')} />
          <Textfieldy label="Версия" {...formy.getFieldProps('desktopappVersion')} />
          <Textfieldy label="Дата публикации" {...formy.getFieldProps('publishedAt')} />
          <Textary label="Содержание" {...formy.getFieldProps('contentMd')} />
          <Buttons>
            <Button {...formy.buttonProps} type="submit">
              Сохранить
            </Button>
          </Buttons>
        </FormItems>
      </Segment>
    </Block>
  )
})
